import type { LinkExternalDto } from '@hcr/api/optimizely'
import type { Link } from '@hcr/ui'

export const createLinkExternal = (dto: LinkExternalDto): Link => ({
  isExternal: true,
  label: dto.label,
  to: dto.url,
})
